import { config } from '@/utils/configuration/config'
import ShipTypeRepoStatic from "@/repositories/shipTypes/ShipTypeRepoStatic"
import ShipTypeRepoFirebase from "@/repositories/shipTypes/ShipTypeRepoFirebase"
import IShipTypeRepo from "@/repositories/shipTypes/IShipTypeRepo"
import RangesForTypeService from "@/services/RangesForTypeService"
import ShipType from "@/model/ShipType"
import Ship from "@/model/Ship"

 class ShipTypeService {
    private static instance: ShipTypeService;
    private shipTypes: Map<string, ShipType>;
    private repo: IShipTypeRepo;
    private getAllTypes: boolean;

    private constructor() {
        //console.log("Construyendo ShipTypeService")
        
        // Se obtiene el valor de la configuración para saber si hay que utilizar firebase o se
        // van a utilizar datos estáticos de prueba
        if (!config.app.useFirebase) {
            this.repo = new ShipTypeRepoStatic() as unknown as IShipTypeRepo
        }
        else {
            this.repo = new ShipTypeRepoFirebase() as unknown as IShipTypeRepo
        }

        this.shipTypes = new Map<string, ShipType>();
        this.getAllTypes = false
     }

    public static getInstance(): ShipTypeService {
        if (!ShipTypeService.instance) {
            ShipTypeService.instance = new ShipTypeService();
        }

        return ShipTypeService.instance;
    }

    private getRef(ref: string, ship: Ship) {
        if(!this.shipTypes.has(ref) && this.repo) {
            //console.log("ShipTypeService - Vamos al repo a buscar el tipo", ref)
            //console.log("Callback: " + this.foundTypeCallback)
            this.repo.getShipType(ref, ship, this.foundTypeCallback)
        } else {
            this.foundTypeCallback(ref, ship, this.shipTypes.get(ref)!)
        }
    }

    private foundTypeCallback(ref: string, ship: Ship, typeElement: ShipType){
        const rangesForType = RangesForTypeService.getRangesForType(ref);
        typeElement.ranges = rangesForType;

        ShipTypeService.getInstance().shipTypes.set(ref, typeElement) 

        ship.shipType = typeElement
        ship.shipTypeStr = typeElement.name
    }

    public static AddShipTypeToShip(ref: string, ship: Ship) {
        //console.log("ref: " + ref)
        this.getInstance().getRef(ref, ship);
    }

    public getTypes(types: Array<Object>){
        if (ShipTypeService.getInstance().getAllTypes) {
            //console.log("Ya debemos tener los tipos")
            ShipTypeService.getInstance().shipTypes.forEach(element => {
                const objForWindow = {
                    id: element.id,
                    name: element.name,
                }
                types.push(objForWindow);
            })
        } else {
            //console.log("Creo que todavía no tenemos los tipos")
            this.repo.getTypes(types, this.addNewShipTypeFromRepo);
            ShipTypeService.getInstance().getAllTypes = true
        }
    }
    private addNewShipTypeFromRepo(types: Array<Object>, doc: ShipType) {
        const objForWindow = {
            id: doc.id,
            name: doc.name,
        }
        types.push(objForWindow)

        const rangesForType = RangesForTypeService.getRangesForType(doc.id);
        doc.ranges = rangesForType;
        ShipTypeService.getInstance().shipTypes.set(doc.id, doc) 
        //console.log("Nuevo tipo recibido", doc)
    }
}

export default ShipTypeService;